import { jsx as o } from "react/jsx-runtime";
import { d as e } from "../../vendor-CPVnY93G.js";
import '../../assets/index29.css';const t = "_surface_tovvp_1", f = {
  surface: t
};
function m({ as: s = "div", children: c, className: r, ...a }) {
  return /* @__PURE__ */ o(s, { ...a, className: e(r, f.surface), "data-component": "Surface", children: c });
}
export {
  m as Surface
};
